import { useQuery } from '@tanstack/react-query'
import { supplierDepositApi } from '@/api/supplier'

// Query Keys
export const supplierDepositKeys = {
  all: ['supplier', 'deposit'] as const,
  balance: () => [...supplierDepositKeys.all, 'balance'] as const,
  logs: () => [...supplierDepositKeys.all, 'logs'] as const,
  logList: (params: { page: number; page_size: number }) =>
    [...supplierDepositKeys.logs(), params] as const,
}

/**
 * 获取保证金余额
 */
export function useSupplierDepositBalance() {
  return useQuery({
    queryKey: supplierDepositKeys.balance(),
    queryFn: () => supplierDepositApi.getBalance(),
  })
}

/**
 * 获取保证金变更记录
 */
export function useSupplierDepositLogs(params: { page: number; page_size: number }) {
  return useQuery({
    queryKey: supplierDepositKeys.logList(params),
    queryFn: () => supplierDepositApi.getLogs(params),
  })
}
